// Função para atualizar o carrinho após adicionar o produto
async function apiCarrinho(formData) {
  try {
    let resposta = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    resposta = await resposta.json();
    if (resposta.sections) {
      let carrinho = resposta.sections["cart-drawer"];
      let divTemporaria = document.createElement('div');
      divTemporaria.innerHTML = carrinho;

      // Substituir o HTML do carrinho
      let novoCarrinhoBox = divTemporaria.querySelector('.drawer__inner').innerHTML;
      document.querySelector('.drawer__inner').innerHTML = novoCarrinhoBox;

      // Reativar listeners após a atualização
      setupOrderbumpListeners();
    }
  } catch (error) {
    console.error("Erro ao atualizar o carrinho:", error);
  }
}

// Função para adicionar o produto ao carrinho
async function adicionarProduto(event) {
  const button = event.currentTarget; // Botão clicado
  const idProduto = Number(button.getAttribute("data-produto"));

  if (!idProduto) {
    console.error("ID do produto inválido");
    return;
  }

  let formData = {
    'items': [{
      'id': idProduto,
      'quantity': 1
    }],
    'sections': "cart-drawer" // Atualize se a seção tiver outro nome no seu tema
  };

  await apiCarrinho(formData);
}

// Torna a função global
window.adicionarProduto = adicionarProduto;
